import React from 'react'
import icon_img from '../../assets/images/icon_img.png'
import { Fade } from 'react-awesome-reveal'



const Catalog = () => {
    return (
        <div>
            <div className='w-full pb-[20vh]'>
                <div className=' text-gray-500  font-semibold  text-sm pb-4 flex justify-center'>OUR VALUE</div>
                <div className='text-slate-50 font-bold text-2xl sm:text-3xl md:text-4xl flex justify-center text-center leading-normal  pb-16 w-full px-[5%] sm:px-[10%] xl:px-[25%]'>
                    Where Strategy Meets Digital. Your Success Story Begins with Digimax.
                </div>
                <div className='flex justify-center'>
                    <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-6 w-[90%] xl:w-[80%] '>
                        <Fade direction='in' className='h-[48vh] lg:h-[52vh] xl:h-[50vh] border-[1px] border-solid border-[#303030] w-full py-4 px-4 rounded-2xl bg-black hover:border-slate-400 transition-all duration-75 shadow-lg shadow-black hover:shadow-slate-600'>
                            <div
                                style={{
                                    backgroundImage: 'linear-gradient(155deg, #1d1d1d 24%, #111 78%)'
                                }}
                                className='h-full w-full rounded-xl pr-2 lg:pr-auto pt-6 pl-6 border-[1px] border-solid border-slate-800 '>
                                <p className='text-slate-50 font-bold text-2xl  leading-normal  pb-4'>
                                    Website Development
                                </p>
                                <p className='font-semibold text-md text text-gray-500 pb-8'>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
                                </p>
                                <button
                                    style={{
                                        backgroundColor: '#181818',
                                        backgroundImage: 'linear-gradient(155deg, #1d1d1d 24%, #111 78%)'
                                    }}
                                    className='py-2 px-8  border-slate-400   border-[1px]   rounded-3xl text-slate-50  font-semibold  text-md text-md relative z-30 '>
                                    Learn More
                                </button>
                            </div>
                        </Fade>
                        <Fade direction='in' className='h-[48vh] lg:h-[52vh] xl:h-[50vh] border-[1px] border-solid border-[#303030] w-full py-4 px-4 rounded-2xl bg-black hover:border-slate-400 transition-all duration-75 shadow-lg shadow-black hover:shadow-slate-600'>
                            <div
                                style={{
                                    backgroundImage: 'linear-gradient(155deg, #1d1d1d 24%, #111 78%)'
                                }}
                                className='h-full w-full rounded-xl pr-2 lg:pr-auto pt-6 pl-6 border-[1px] border-solid border-slate-800'>
                                <p className='text-slate-50 font-bold text-2xl  leading-normal  pb-4'>
                                    Website Development
                                </p>
                                <p className='font-semibold text-md text text-gray-500 pb-8'>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
                                </p>
                                <button
                                    style={{
                                        backgroundColor: '#181818',
                                        backgroundImage: 'linear-gradient(155deg, #1d1d1d 24%, #111 78%)'
                                    }}
                                    className='py-2 px-8  border-slate-400   border-[1px]   rounded-3xl text-slate-50  font-semibold  text-md text-md relative z-30 '>
                                    Learn More
                                </button>
                            </div>
                        </Fade>
                        <Fade direction='in' className='h-[48vh] lg:h-[52vh] xl:h-[50vh] border-[1px] border-solid border-[#303030] w-full py-4 px-4 rounded-2xl bg-black hover:border-slate-400 transition-all duration-75 shadow-lg shadow-black hover:shadow-slate-600'>
                            <div
                                style={{
                                    backgroundImage: 'linear-gradient(155deg, #1d1d1d 24%, #111 78%)'
                                }}
                                className='h-full w-full rounded-xl pr-2 lg:pr-auto pt-6 pl-6 border-[1px] border-solid border-slate-800'>
                                <p className='text-slate-50 font-bold text-2xl  leading-normal  pb-4'>
                                    Website Development
                                </p>
                                <p className='font-semibold text-md text text-gray-500 pb-8'>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
                                </p>
                                <button
                                    style={{
                                        backgroundColor: '#181818',
                                        backgroundImage: 'linear-gradient(155deg, #1d1d1d 24%, #111 78%)'
                                    }}
                                    className='py-2 px-8  border-slate-400   border-[1px]   rounded-3xl text-slate-50  font-semibold  text-md text-md relative z-30 '>
                                    Learn More
                                </button>
                            </div>
                        </Fade>
                        <Fade direction='in' className='h-[48vh] lg:h-[52vh] xl:h-[50vh] border-[1px] border-solid border-[#303030] w-full py-4 px-4 rounded-2xl bg-black hover:border-slate-400 transition-all duration-75 shadow-lg shadow-black hover:shadow-slate-600'>
                            <div
                                style={{
                                    backgroundImage: 'linear-gradient(155deg, #1d1d1d 24%, #111 78%)'
                                }}
                                className='h-full w-full rounded-xl pr-2 lg:pr-auto pt-6 pl-6 border-[1px] border-solid border-slate-800'>
                                <p className='text-slate-50 font-bold text-2xl  leading-normal  pb-4'>
                                    Website Development
                                </p>
                                <p className='font-semibold text-md text text-gray-500 pb-8'>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
                                </p>
                                <button
                                    style={{
                                        backgroundColor: '#181818',
                                        backgroundImage: 'linear-gradient(155deg, #1d1d1d 24%, #111 78%)'
                                    }}
                                    className='py-2 px-8  border-slate-400   border-[1px]   rounded-3xl text-slate-50  font-semibold  text-md text-md relative z-30 '>
                                    Learn More
                                </button>
                            </div>
                        </Fade>
                        <Fade direction='in' className='h-[48vh] lg:h-[52vh] xl:h-[50vh] border-[1px] border-solid border-[#303030] w-full py-4 px-4 rounded-2xl bg-black hover:border-slate-400 transition-all duration-75 shadow-lg shadow-black hover:shadow-slate-600'>
                            <div
                                style={{
                                    backgroundImage: 'linear-gradient(155deg, #1d1d1d 24%, #111 78%)'
                                }}
                                className='h-full w-full rounded-xl pr-2 lg:pr-auto pt-6 pl-6 border-[1px] border-solid border-slate-800'>
                                <p className='text-slate-50 font-bold text-2xl  leading-normal  pb-4'>
                                    Website Development
                                </p>
                                <p className='font-semibold text-md text text-gray-500 pb-8'>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
                                </p>
                                <button
                                    style={{
                                        backgroundColor: '#181818',
                                        backgroundImage: 'linear-gradient(155deg, #1d1d1d 24%, #111 78%)'
                                    }}
                                    className='py-2 px-8  border-slate-400   border-[1px]   rounded-3xl text-slate-50  font-semibold  text-md text-md relative z-30 '>
                                    Learn More
                                </button>
                            </div>
                        </Fade>
                        <Fade direction='in' className='h-[48vh] lg:h-[52vh] xl:h-[50vh] border-[1px] border-solid border-[#303030] w-full py-4 px-4 rounded-2xl bg-black hover:border-slate-400 transition-all duration-75 shadow-lg shadow-black hover:shadow-slate-600'>
                            <div
                                style={{
                                    backgroundImage: 'linear-gradient(155deg, #1d1d1d 24%, #111 78%)'
                                }}
                                className='h-full w-full rounded-xl pr-2 lg:pr-auto pt-6 pl-6 border-[1px] border-solid border-slate-800'>
                                <p className='text-slate-50 font-bold text-2xl  leading-normal  pb-4'>
                                    Website Development
                                </p>
                                <p className='font-semibold text-md text text-gray-500 pb-8'>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
                                </p>
                                <button
                                    style={{
                                        backgroundColor: '#181818',
                                        backgroundImage: 'linear-gradient(155deg, #1d1d1d 24%, #111 78%)'
                                    }}
                                    className='py-2 px-8  border-slate-400   border-[1px]   rounded-3xl text-slate-50  font-semibold  text-md text-md relative z-30 '>
                                    Learn More
                                </button>
                            </div>
                        </Fade>
                    </div>
                </div>
            </div>
            <div></div>
        </div>
    )
}

export default Catalog
